import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Layout, Grid, Row, Space, Col } from 'antd'
import { useAuth } from 'auth-context'
import { useWindowDimensions } from 'pollination-react-io'
import { AccountOptions } from './AccountOptions'
import { HelpOptions } from './HelpOptions'
import { useAccountInfo } from 'hooks/useAccountInfo'

export const Header = (): React.ReactElement => {
  const { user, logout, registered } = useAuth()
  const { setAccountInfo } = useAccountInfo()

  const { xs } = Grid.useBreakpoint()
  const { width } = useWindowDimensions()

  useEffect(() => {
    user && setAccountInfo && setAccountInfo({
      name: user?.name,
      display_name: user?.name,
      picture: user?.picture,
      owner: true,
      type: 'user'
    })
  }, [user])

  return (
    <Layout.Header
      style={{
        background: 'white',
        borderBottom: '1px solid #91d5ff',
        padding: '0 16px',
        margin: 0
      }}>
      <Row justify={'space-between'}>
        {/* Home button */}
        <Col>
          <Link to="/">
            <img src="/brandmark.svg" alt="Pollination Logo" style={{ height: xs ? 26 : 30, marginBottom: 4 }} />
          </Link>
        </Col>
        <Col>
          <Space align='center'
            direction='horizontal'
            size={xs ? 'small' : 'middle'}>

            {/* Help options - limit iPhoneSE width */}
            {width > 375 && user && registered && <HelpOptions
              disabled={typeof user === 'undefined'}
            />}

            {/* Account options */}
            {user && registered && <AccountOptions
              disabled={typeof user === 'undefined'}
              logout={logout}
            />}
          </Space>
        </Col>
      </Row>
    </Layout.Header>
  )
}

export default Header
